export default "__VITE_ASSET__yacUQRiG__"